import React, { useState, useEffect, useContext  } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "./../www/style.css";
import { NavLink as RRNavLink, Outlet } from "react-router-dom";
import moment from "moment";
import { CLOSE_IMAGE } from "../Image";
import {LineChart} from 'amazing-react-charts'
import { MDBIcon, MDBTabs, MDBTabsLink, MDBTabsContent, MDBTabsPane, MDBInput, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StoreContext from "./../Store/Context";
import BarChartIcon from '@mui/icons-material/BarChart';
import ClearIcon from '@mui/icons-material/Clear';
import {GastosModal, DeleteModal, DateRangeModal} from './../Modal';
import {DATATABLE_GASTOS} from "../Datatables";
import {get_gas_gastos,get_tipo_gastos,imgURLServerGastos,monthname,post_gas_gastos,put_delete_img,put_delete_img_gastos,put_gas_gastos,put_gas_gastos_sts,descargar_zip} from "../Services";
import { Container,Row, Col, Label,NavLink } from "reactstrap";
import { STATES_GAS_GASTOS } from "../States";
import { IconButton,Button,Box } from "@mui/material";
import { EXPORT_CSV_GASTOS } from "../Util";
export const Gastos = () => {
  const { usr_sucursal } = useContext(StoreContext);
  const [flagGrafica, setOpenFlag] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoadingG, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [monto_gastos, setMontoGastos] = useState("");
  const [dataGastos, setDataGastos] = useState([]);
  const [dataTipo, setDataTipo] = useState([]);
  const [dataChartGastos, setChartGastos] = useState([]);
  const [images, setImages] = React.useState([]);
  const [formTipoGastos, setFormTipoGastos] = useState(STATES_GAS_GASTOS({staneName:"formTipoGastos"}));
  const [formGastos, setFormGastos] = useState(STATES_GAS_GASTOS({staneName:"formGastos"}));
  const [valueSelected, setValueSelected] = useState("");
  const [open, setOpen] = useState(false);
  const [isDateRangeOpen, setDateRange] = useState(false);
  const [state, setState] = useState([{
    startDate: moment(new Date()).format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    key: "selection"
  }]);
  const onClickUpdateGastos = () => {
    setLoading(true)
    var body = {
      gs_id: formGastos.gs_id,
      gs_suc:usr_sucursal,
      gs_tipo:formGastos.gs_tipo,
      gs_desc: formGastos.gs_desc,
      gs_monto:formGastos.gs_monto,
      gs_fecha:formGastos.gs_fecha,
      gs_imgType:formGastos.gs_imgType !== "" ? formGastos.gs_imgType : "none",
      gs_imgName:formGastos.gs_imgType !== undefined? moment(new Date()).format("YYYYMMDDHHmmss"): formGastos.gs_imgName,
      gs_file:formGastos.gs_file,
      imgURLServerGastos:imgURLServerGastos
    };

    var result = put_gas_gastos(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchGastos({date:formGastos.gs_fecha});
      }
       
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateGastos_sts = () => {
    var body = {
      gs_id: formGastos.gs_id,
      gs_sts: 0,
    };


    var result = put_gas_gastos_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchGastos({date:formGastos.gs_fecha});
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveGastos = () => {
    setLoading(true)
    var body = {
      gs_monto:formGastos.gs_monto,
      gs_suc:usr_sucursal,
      gs_desc:formGastos.gs_desc,
      gs_tipo:formGastos.gs_tipo,
      gs_fecha:formGastos.gs_fecha,
      gs_imgType:formGastos.gs_imgType !== "" ? formGastos.gs_imgType : "none",
      gs_imgName:formGastos.gs_imgType !== undefined? moment(new Date()).format("YYYYMMDDHHmmss"): formGastos.gs_imgName,
      gs_file:formGastos.gs_file,
      imgURLServerGastos:imgURLServerGastos
    };
    if (formGastos.gs_monto.length > 0 && formGastos.gs_tipo.length > 0) {
      var result = post_gas_gastos(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false)
          fetchGastos({date:formGastos.gs_fecha});
        }
        
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchGastos({date}) {
    setLoading(true);
    var response;
    response = await get_gas_gastos({date});
    setDataGastos(response.gastos);
    setMontoGastos(response.monto[0]);
    var dataChart = response.gastos.map((data,i)=>{
      return{
        label:data.tgs_desc,
        result: data.gs_monto,
        mes:monthname[Number(moment(data.gs_fecha).month())].name,
        itemId: 1,
      }
      //  
    });
    setChartGastos(dataChart)
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoading(false);
    setError("");
  }

  async function fetchTipoGastos() {
    setLoading(true);
    var response;
    response = await get_tipo_gastos();
    setDataTipo(response);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormGastos({
      ...formGastos,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchGastos({date:moment(new Date()).format("YYYY-MM-DD")});
    fetchTipoGastos();
  }, []);

  const onChangeDropdown = (selectedOptions) => {
        setFormGastos({
      ...formGastos,
      gs_tipo: selectedOptions.value,
    });

    setValueSelected(selectedOptions.label)
  };
  
  const handle_descargar_zip = () => {
    var body ={
      url:imgURLServerGastos,
      date:formGastos.gs_fecha
    }
    descargar_zip(body)
  };

  const handleExportCsvGastos = () => {
    EXPORT_CSV_GASTOS({dataGastos:dataGastos})
  };
  const onChangeImage = (imageList) => {
    setFormGastos({
      ...formGastos,
      gs_file: imageList[0]===undefined?"":imageList[0].data_url,
      gs_imgType: imageList[0]===undefined?"":imageList[0].file.type,
    });
    setImages(imageList);
  };
    const handleOnChangeDate = (ranges) => {
      fetchGastos({date:moment(ranges).format("YYYY-MM-DD")})
      setFormGastos({
      ...formGastos,
      gs_fecha:moment(ranges).format("YYYY-MM-DD") ,
    });
      setDateRange(false)
      // }
    };
      const removeImage = (data) => {
        if (basicModalEdit) {
          var body = {
            gs_id: data,
          };
    
          var result = put_delete_img_gastos(body);
          result.then((data) => {
            setError("");
            if(data===true)
              setFormGastos({
                ...formGastos,
                gs_file: "",
                gs_imgType:"",
              });
            else
              setError("ERROR "+data);
          });
    
        }
      };

  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <GastosModal
          props={formGastos}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveGastos}
          toggleSaveEdit={onClickUpdateGastos}
          onChange={onChange}
          removeImage={removeImage}
          onChangeImage={onChangeImage}
          error={error}
          loading={isLoadingG}
          images={images}
          dataTipo={dataTipo}
          onChangeDropdown={onChangeDropdown}
          valueSelected={valueSelected}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formGastos.gs_desc}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateGastos_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )} 
      {isDateRangeOpen && (
        <DateRangeModal
          isOpen={isDateRangeOpen}
          toggle={setDateRange}
          show_year_month={true}
          open={open}
          handleOnChangeDate={handleOnChangeDate}
          state={state}
        />
      )}
      <Row className="mt-3">
        <Col sm={4} md={2} className="text-end">
          <MDBInput
              className="input-iventario-totales"
              label="TOTAL DE GASTOS"
              autoFocus={true}
              value={monto_gastos.gs_monto != null ? Number(Number(monto_gastos.gs_monto)).toFixed(2) : ""}
              disabled={true}
            />
        </Col>
        <Col sm={1} md={6}></Col>
        <Col sm={6} md={3} className="text-right text-end">
          <IconButton onClick={() => {setOpenFlag(true)}}>
                  <BarChartIcon />
                </IconButton>
        <IconButton onClick={() => {
            setOpen(true); setDateRange(true); setState([{
              startDate: moment(new Date()).format("YYYY-MM-DD"),
              endDate: moment(new Date()).format("YYYY-MM-DD"),
              key: "selection"
            }])
          }}>
            <CalendarMonthIcon />
          </IconButton>
          {state[0].startDate !== "" && state[0].endDate !== "" && (
            <Label className="font-weight-bold-title-report">Mes :  {" "}
              {monthname[Number(moment(formGastos.gs_fecha).month())].name} {" "}
              {moment("2025-03-15").year()}
            </Label>
          )}

        </Col>
        <Col sm={1} md={1}>
          <NavLink tag={RRNavLink} to="/user/home" className="font-w-bold   menu-l-c">
            <img src={CLOSE_IMAGE} className="src-image" alt="..."/>
          </NavLink>
        </Col>
        {flagGrafica?
        <Col xs ={12} className="text-end">
          <IconButton onClick={() => {setOpenFlag(false)}}>
                <ClearIcon />
              </IconButton>
              <LineChart
              showBarLabel
              yComplement="$"
              xType="category"
              yType="value"
              colors={['red', 'green', 'blue']}
              title="GRÁFICA DE GASTOS MENSUALES"
              toolboxTooltip={{ saveAsImage: 'save' }}
              // tooltip={{ label: 'Equipamento', result: 'Disponibilidade' }}
              data={[{name:"Gastos",values:dataChartGastos}]}
            />
        </Col>
              :<Col className="modal-add-inventario datatable-factura css_datatable1 mt-3">
        <DATATABLE_GASTOS dataGastos ={dataGastos} 
        setBasicModalDelete={setBasicModalDelete}
        setImages={setImages}
        setFormGastos={setFormGastos}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchGastos={fetchGastos}
        setValueSelected={setValueSelected}
        isLoadingM={isLoadingG}
        handleExportData={handleExportCsvGastos}
        descargar_zip={handle_descargar_zip}
         />
        </Col>
        }
        
      </Row>
    </Container>
  );
};

